import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { WarehousingSearchService } from '../../services/warehousing-search.service';
import { DatePipe } from '@angular/common';
import * as ValidationUtils from 'src/app/core/utils/validation-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { LocationOption } from 'src/app/shared/components/model/LocationOption';

@Component({
  selector: 'laas-warehousing-edit',
  templateUrl: './warehousing-edit.component.html',
  styleUrls: ['./warehousing-edit.component.scss']
})
export class WarehousingEditComponent extends SessionBaseComponent implements OnInit {

  readonly ExpressTermEditPermissionCode: PermissionConstants = PermissionConstants.EditWarehousingFormExpressTerm;

  warehousingHeader: any;
  warehousingOriginHeader: any;
  editForm: FormGroup;
  forwarderOptions: any[];
  billObjectTypeOptions: any[];
  billObjectOptions: any[];
  vendorCustomerOptions: any[];
  vendorSuggests: string[] = [];
  deliveryTypeOptions: any[];
  orgIdOptions: any[];
  billCorpOptions: any[];
  countryOptions: any[];
  allCityOptions: any[];
  allAreaOptions: any[];
  fromCityOptions: any[];
  fromAreaOptions: any[];
  toCityOptions: any[];
  toAreaOptions: any[];
  expressTermOptions: LaasOption[];
  docTypeOptions: any[];
  shipTermOptions: any[];
  uomOptions: any[];
  brandOptions: any[];
  shippingRemarkOptions: any[];
  yesNoOptions: any[];
  addressCodeOptions: any[];
  shippingMethodOptions: any[];
  deliverySubTypeOptions: any[];
  submitted: boolean;
  whDocStatusOptions : any[] = [];
  warehousing: any;
  urgentFlagOptions: any[];
  defaultBillCorpOptions : any[] = [];
  idEditDeliveryType: boolean = true;
  isShipperEdit = false;
  isExpressTermEdit = false;
  isShipTermEdit = false;
  preOrgId:string = "";
  orgIdMappingOptions: any[];
  allCountryOptions: LocationOption[] = [];
  feiliksNotifyFlagOptions: LaasOption[] = [
    { label: 'Y',value: 'Y' },
    { label: 'N',value: 'N' }
  ];

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private warehousingSearchService: WarehousingSearchService,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.forwarderOptions = [];
    this.billObjectTypeOptions = [];
    this.billObjectOptions = [];
    this.vendorCustomerOptions = [];
    this.deliveryTypeOptions = [];
    this.orgIdOptions = [];
    this.billCorpOptions = [];
    this.countryOptions = [];
    this.allCityOptions = [];
    this.allAreaOptions = [];
    this.fromCityOptions = [];
    this.fromAreaOptions = [];
    this.toCityOptions = [];
    this.toAreaOptions = [];
    this.expressTermOptions = [];
    this.docTypeOptions = [];
    this.shipTermOptions = [];
    this.uomOptions = [];
    this.brandOptions = [];
    this.shippingRemarkOptions = [];
    this.yesNoOptions = [];
    this.addressCodeOptions = [];
    this.shippingMethodOptions = [];
    this.deliverySubTypeOptions = [];
    this.submitted = false;
    this.orgIdMappingOptions = [];

    this.warehousingHeader =  {
      facility: '',
      whNo: '',
      shipper: '',
      billObjectType: '',
      billObject: '',
      vendorCustomer: '',
      deliveryType: '',
      orgId: '',
      billCorp: '',
      fromCountry: '',
      fromCity: '',
      fromArea: '',
      toCountry: '',
      toCity: '',
      toArea: '',
      expressTerm: '',
      docType: '',
      shipTerm: '',
      whDtTimeZone: '',
      expectedDtTimeZone: '',
      hawbNo: '',
      palletCnt: '',
      totalCartonCnt: '',
      totalChargeableWeight: '',
      totalGrossWeight: '',
      totalVolumeWeight: '',
      rfCaseCnt: '',
      totalQty: '',
      cartonCnt: '',
      uom: '',
      uomQty: '',
      bondedNo: '',
      bulkCargoNo: '',
      brand: '',
      shippingRemark: '',
      isDropShipment: '',
      isGenerateFee: '',
      addressCode: '',
      deliveryAddress: '',
      urgentFlag: '',
      flightNo: '',
      flightDtTimeZone: '',
      shippingMethod: '',
      mawbNo: '',
      impDocNo: '',
      docNo1: '',
      docNo2: '',
      docNo3: '',
      docNo4: '',
      docNo5: '',
      deliverySubType: '',
      doNo: '',
      splitDept: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: '',
      quotationKey: '',
      whStatus: '',
      employCode: '',
      bulkCargoNoLocation: '',
      isAbnormalNotify: 1,
      feiliksNotifyFlag: '',
    };

    this.editForm = this.fb.group({
      facility: '',
      whNo: '',
      shipper: ['', Validators.required ],
      billObjectType: ['', Validators.required ],
      billObject: ['', Validators.required ],
      vendorCustomer: ['', Validators.required],
      deliveryType: ['', Validators.required],
      orgId: '',
      billCorp: '',
      fromLocation: [null, Validators.required], // 起運地巢狀結構：{country, city, area}
      toLocation: [null], // 目的地巢狀結構：{country, city, area}
      consolidationFromLocation: [null], // 目的地巢狀結構：{country, city, area}
      consolidationToLocation: [null], // 目的地巢狀結構：{country, city, area}
      consolidationForwarder: [null],
      crossBoundryForwarder: [null],
      expressTerm: '',
      docType: '',
      shipTerm: '',
      whDtTimeZone: '',
      expectedDtTimeZone: '',
      hawbNo: ['', Validators.required ],
      palletCnt: '',
      totalCartonCnt: ['', Validators.required ],
      totalChargeableWeight:  ['', Validators.required ],
      totalGrossWeight: '',
      totalVolumeWeight: '',
      rfCaseCnt: '',
      totalQty: '',
      totalQtyExpected: '',
      cartonCnt: '',
      uom: '',
      uomQty: '',
      bondedNo: '',
      bulkCargoNo: '',
      brand: '',
      shippingRemark: '',
      isDropShipment:  ['', Validators.required ],
      isGenerateFee:  ['', Validators.required ],
      addressCode: ['', Validators.required ],
      deliveryAddress: '',
      urgentFlag: ['', Validators.required ],
      flightNo: '',
      flightDtTimeZone: '',
      shippingMethod: '',
      mawbNo: '',
      impDocNo: '',
      docNo1: [null, [ Validators.maxLength(2)]],
      docNo2: [null, [ Validators.maxLength(2)]],
      docNo3: [null, [ Validators.maxLength(2)]],
      docNo4: [null, [ Validators.maxLength(4)]],
      docNo5: [null, [ Validators.maxLength(5)]],
      deliverySubType: '',
      doNo: '',
      splitDept: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: '',
      quotationKey: '',
      whStatus: '',
      employCode: '',
      bulkCargoNoLocation: '',
      isAbnormalNotify:  [1, Validators.required ],
      feiliksNotifyFlag:  [1, Validators.required ],
    });

    this.urgentFlagOptions= [];

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.yesNoOptions = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.urgentFlagOptions= [
      { label: '非急單', value: '5' },
      { label: '急單', value: '1' }
    ];

    const whNo = this.routeStateService.getCurrent().data.whNo;

    try {
      this.warehousingHeader = await this.warehousingSearchService.searchWarehousingByWhNo(whNo);
      this.warehousingOriginHeader = { ...this.warehousingHeader };

      // 處理 docNo 分割
      this.processDocNo();

      // 處理日期時間轉換
      this.processDateTimeConversion();

      // 設定表單位置資料
      this.setLocationDataToForm();
    } catch (err: any) {
      console.log('get warehousing header occur error:' + err);
    }

    this.facilityService.getForwarderOptions(this.warehousingHeader.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });

      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliveryType').subscribe({
      next: result => {
        this.deliveryTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });

      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectOptions(this.warehousingHeader.facility, this.warehousingHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.warehousingHeader.facility, "").subscribe({
      next: result => {
        this.orgIdMappingOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}(${x.legalEntityReferenceCode})`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    this.facilityService.getOrgOptionsByWhDetail(this.warehousingHeader.facility, this.warehousingHeader.whNo).subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}(${x.legalEntityReferenceCode})`,
            value: x.legalEntityOUCode,
          };
        });

        this.defaultBillCorpOptions = [...result].filter(x => x.billOUCode !== null).map((x: any) => {
          return {
            label: `${x.billReferenceCode}-${x.billOUName}(${x.billOUCode})`,
            value: x.billOUCode,
          };
        });

        this.preOrgId = this.warehousingHeader.orgId;
      }
    });

    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
      }
    });

    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.allCityOptions = [...result].map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
            country: x.country
          };
        });
        this.fromCityOptions = this.allCityOptions.filter(x => x.country === this.warehousingHeader.fromCountry);
        this.toCityOptions = this.allCityOptions.filter(x => x.country === this.warehousingHeader.toCountry);

      }
    });

    this.dropdownOptionsService.getAllAreaOptionForHK().subscribe({
      next: result => {
        this.allAreaOptions = [...result].map((x: any) => {
          return {
            label: x.rfqAreaName,
            value: x.rfqAreaCode,
            citySeqNo : x.citySeqNo,
          };
        });
        this.fromAreaOptions = this.allAreaOptions.filter(x => x.citySeqNo?.toString() === this.warehousingHeader.fromCity);

        this.toAreaOptions = this.allAreaOptions.filter(x => x.citySeqNo?.toString() === this.warehousingHeader.toCity);

      }
    });

    this.dropdownOptionsService.findFacilityOptionsByOptionType('ExpressTerm')
      .subscribe({
        next: (options: FacilityOptions[]) => {
          this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });

      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.shipTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.dropdownOptionsService.getCarTypeOptions().subscribe({
      next: result => {
        this.uomOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBrandOptions(1).subscribe({
      next: result => {
        this.brandOptions = [...result].map((x: any) => {
          return {
            label: x.brandName,
            value: x.brandCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShippingRemark').subscribe({
      next: result => {
        this.shippingRemarkOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getPickupLocationOptionByDefault(this.laasSetting.facility).subscribe({
      next: result => {
        this.addressCodeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });

      }
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shippingMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliverySubType').subscribe({
      next: result => {
        this.deliverySubTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });

      }
    });

    this.dropdownOptionsService.getWhDocStatusOptions()
    .subscribe({
      next: (options: any[]) => {
        this.whDocStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getVendorOptions(`${this.warehousingHeader.vendorCustomer}`).subscribe({
      next: result => {
        this.vendorCustomerOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      }
    });

    this.isShipperEdit = this.warehousingHeader.deliveryType !== 'DECLARATION';

    this.isExpressTermEdit = this.permissionCodes.includes(this.ExpressTermEditPermissionCode)
        && 'Y' !== this.warehousingHeader.isFeeCalculation;

    this.isShipTermEdit = this.warehousingHeader.whStatus =='0' && this.warehousingHeader.deliveryType !== 'LOCAL';
    this.changeValidation();

  }

  /**
   * 處理 docNo 分割
   */
  private processDocNo(): void {
    let docNo = this.warehousingHeader?.docNo;
    const docNoArr = docNo ? docNo.split('/') : [];

    docNoArr.forEach((element: string, index: number) => {
      this.warehousingHeader['docNo' + (index + 1).toString()] = element;
      if (index === 1 && isNullOrEmpty(element)) {
        this.warehousingHeader['docNo' + (index + 1).toString()] = '　';
      }
    });
  }

  /**
   * 處理日期時間轉換
   */
  private processDateTimeConversion(): void {
    this.warehousingHeader.whDtTimeZone = this.datePipe.transform(
      this.warehousingHeader.whDt,
      'yyyy/MM/dd hh:mm',
      this.laasSetting.facilityTimeZone
    );

    this.warehousingHeader.expectedDtTimeZone = this.datePipe.transform(
      this.warehousingHeader.expectedDt,
      'yyyy/MM/dd',
      this.laasSetting.facilityTimeZone
    );

    this.warehousingHeader.flightDtTimeZone = this.datePipe.transform(
      this.warehousingHeader.flightDt,
      'yyyy/MM/dd',
      this.laasSetting.facilityTimeZone
    );
  }

  /**
   * 設定位置資料到表單
   */
  private setLocationDataToForm(): void {
    // 組合起運地資料
    const fromLocation = {
      country: this.warehousingHeader.fromCountry || null,
      city: this.warehousingHeader.fromCity || null,
      area: this.warehousingHeader.fromArea || null
    };

    // 組合目的地資料
    const toLocation = {
      country: this.warehousingHeader.toCountry || null,
      city: this.warehousingHeader.toCity || null,
      area: this.warehousingHeader.toArea || null
    };

    // 組合起運地資料
    const consolidationFromLocation = {
      country: this.warehousingHeader.consolidationFromCountry || null,
      city: this.warehousingHeader.consolidationFromCity || null,
      area: this.warehousingHeader.consolidationFromArea || null
    };

    // 組合目的地資料
    const consolidationToLocation = {
      country: this.warehousingHeader.consolidationToCountry || null,
      city: this.warehousingHeader.consolidationToCity || null,
      area: this.warehousingHeader.consolidationToArea || null
    };

    // 設定到表單（使用 setTimeout 確保連動元件已初始化）
    setTimeout(() => {
      this.editForm.patchValue({
        fromLocation: fromLocation,
        toLocation: toLocation,
        consolidationFromLocation: consolidationFromLocation,
        consolidationToLocation: consolidationToLocation
      }, { emitEvent: false });

      console.log('Location data set to form:', { fromLocation, toLocation, consolidationFromLocation, consolidationToLocation });
    }, 100);
  }

  // changeFromCityOptions(): void {
  //   this.warehousingHeader.fromCity = '';
  //   this.warehousingHeader.fromArea = '';
  //   this.fromCityOptions = this.allCityOptions.filter(x => x.country === this.warehousingHeader.fromCountry);
  //   this.fromCityOptions.unshift({
  //     label: '請選擇',
  //     value: ''
  //   });
  //   this.fromAreaOptions = [];
  // }

  // changeFromAreaOptions(): void {
  //   this.warehousingHeader.fromArea = '';
  //   this.fromAreaOptions = this.allAreaOptions.filter(x => x.citySeqNo.toString() === this.warehousingHeader.fromCity);
  //   this.fromAreaOptions.unshift({
  //     label: '請選擇',
  //     value: ''
  //   });
  // }

  // changeToCityOptions(): void {
  //   this.warehousingHeader.toCity = '';
  //   this.warehousingHeader.toArea = '';
  //   this.toCityOptions = this.allCityOptions.filter(x => x.country === this.warehousingHeader.toCountry);
  //   this.toCityOptions.unshift({
  //     label: '請選擇',
  //     value: ''
  //   });
  //   this.toAreaOptions = [];
  // }

  // changeToAreaOptions(): void {
  //   this.warehousingHeader.toArea = '';
  //   this.toAreaOptions = this.allAreaOptions.filter(x => x.citySeqNo.toString() === this.warehousingHeader.toCity);
  //   this.toAreaOptions.unshift({
  //     label: '請選擇',
  //     value: ''
  //   });
  // }

  /**
   * 接收國家選項 - 用於建立備用選項陣列
   */
  onCountryOptionsReady(options: LocationOption[]): void {
    this.allCountryOptions = options;
    console.log('Country options ready:', options.length);

    // 建立原有格式的國家選項（如果其他功能需要）
    this.countryOptions = options.map(option => ({
      label: option.label || option.countryName,
      value: option.value || option.countryCode,
      country: option.countryCode
    }));
  }

  /**
   * 接收城市選項 - 用於建立備用選項陣列
   */
  onCityOptionsReady(options: LocationOption[]): void {
    console.log('City options ready:', options.length);

    // 建立原有格式的城市選項（如果其他功能需要）
    this.allCityOptions = options.map(option => ({
      label: option.label || option.cityName,
      value: option.value || option.seqNo?.toString(),
      country: option.country || option.countryCode,
      citySeqNo: option.seqNo
    }));
  }

  /**
   * 接收區域選項 - 用於建立備用選項陣列
   */
  onAreaOptionsReady(options: LocationOption[]): void {
    console.log('Area options ready:', options.length);

    // 建立原有格式的區域選項（如果其他功能需要）
    this.allAreaOptions = options.map(option => ({
      label: option.label || option.areaName,
      value: option.value || option.areaCode,
      citySeqNo: option.citySeqNo || option.seqNo
    }));
  }

  getVendorOptions(event: any): void {
    const key: string = event.query;

    if (key != null && key.length > 0 ){
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: result => {
          this.vendorCustomerOptions = [...result].map((x: any) => {
            return {
              label: x.optionDesc,
              value: x.optionCode,
            };
          });

          this.vendorSuggests = [...result].map(x => x.optionDesc);
        }
      });
    }
  }

  checkBillObjectType(): boolean {
    return this.warehousingHeader.billObjectType == 'V';
  }

  handleString(str: string): string{
    return isNullOrEmpty(str) ? '' : str;
  }

  saveBtnClick(event: any): void {
    this.submitted = true;

    // 處理供應商資料
    this.processVendorCustomer();

    // 驗證表單
    if (this.editForm.invalid) {
      console.log('Form controls:', this.editForm.controls);
      this.toastService.warn('請檢查是否有必填欄位尚未填寫');
      return;
    }

    // 同步位置資料到 warehousingHeader
    this.syncLocationDataToHeader();

    // 轉換 docNo 和日期時間
    this.convertDocNoAndDateTime();

    // 驗證日期欄位
    if (!this.validateDateFields()) {
      return;
    }

    // 驗證 HAWB 長度
    if (!this.validateHawbLength()) {
      return;
    }

    console.log('Saving warehousing header:', this.warehousingHeader);

    // 儲存資料
    this.saveWarehousingData();
  }

  /**
   * 處理供應商資料
   */
  private processVendorCustomer(): void {
    if (!isNullOrEmpty(this.warehousingHeader.vendorCustomer)) {
      let vendorTmp = this.warehousingHeader.vendorCustomer;
      let vendorTmpArray = this.vendorCustomerOptions.filter(x => {
        return x.label === vendorTmp;
      });

      if (vendorTmpArray.length > 0) {
        let temp = vendorTmpArray[0].label;
        let label = temp.substring(temp.lastIndexOf('-') + 2, temp.length);
        this.warehousingHeader.vendorCustomerName = label;
        this.warehousingHeader.vendorCustomer = vendorTmpArray[0].value;
      } else {
        this.warehousingHeader.vendorCustomerName = this.warehousingHeader.vendorCustomer;
      }
    }
  }

  /**
   * 同步位置資料到 warehousingHeader
   */
  private syncLocationDataToHeader(): void {
    const fromLocation = this.editForm.value.fromLocation;
    const toLocation = this.editForm.value.toLocation;

    if (fromLocation) {
      this.warehousingHeader.fromCountry = fromLocation.country || null;
      this.warehousingHeader.fromCity = fromLocation.city || null;
      this.warehousingHeader.fromArea = fromLocation.area || null;
    }

    if (toLocation) {
      this.warehousingHeader.toCountry = toLocation.country || null;
      this.warehousingHeader.toCity = toLocation.city || null;
      this.warehousingHeader.toArea = toLocation.area || null;
    }

    const consolidationFromLocation = this.editForm.value.consolidationFromLocation;
    const consolidationLocation = this.editForm.value.consolidationToLocation;

    if (consolidationFromLocation) {
      this.warehousingHeader.consolidationFromCountry = consolidationFromLocation.country || null;
      this.warehousingHeader.consolidationFromCity = consolidationFromLocation.city || null;
      this.warehousingHeader.consolidationFromArea = consolidationFromLocation.area || null;
    }

    if (consolidationLocation) {
      this.warehousingHeader.consolidationToCountry = consolidationLocation.country || null;
      this.warehousingHeader.consolidationToCity = consolidationLocation.city || null;
      this.warehousingHeader.consolidationToArea = consolidationLocation.area || null;
    }

    console.log('Location data synced to header:', {
      from: {
        country: this.warehousingHeader.fromCountry,
        city: this.warehousingHeader.fromCity,
        area: this.warehousingHeader.fromArea
      },
      to: {
        country: this.warehousingHeader.toCountry,
        city: this.warehousingHeader.toCity,
        area: this.warehousingHeader.toArea
      },
      consolidationFrom: {
        country: this.warehousingHeader.consolidationFromCountry,
        city: this.warehousingHeader.consolidationFromCity,
        area: this.warehousingHeader.consolidationFromArea
      },
      consolidationTo: {
        country: this.warehousingHeader.consolidationToCountry,
        city: this.warehousingHeader.consolidationToCity,
        area: this.warehousingHeader.consolidationToArea
      },
    });
  }

  /**
   * 轉換 docNo 和日期時間格式
   */
  private convertDocNoAndDateTime(): void {
    // 轉換 docNo
    this.warehousingHeader.docNo = `${this.handleString(this.warehousingHeader.docNo1)}/${this.handleString(this.warehousingHeader.docNo2)}/${this.handleString(this.warehousingHeader.docNo3)}/${this.handleString(this.warehousingHeader.docNo4)}/${this.handleString(this.warehousingHeader.docNo5)}`;

    // 轉換日期時間
    this.warehousingHeader.whDt = isNullOrEmpty(this.warehousingHeader.whDtTimeZone)
      ? null
      : new Date(this.warehousingHeader.whDtTimeZone).toISOString();

    this.warehousingHeader.expectedDt = isNullOrEmpty(this.warehousingHeader.expectedDtTimeZone)
      ? null
      : new Date(this.warehousingHeader.expectedDtTimeZone).toISOString();

    this.warehousingHeader.flightDt = isNullOrEmpty(this.warehousingHeader.flightDtTimeZone)
      ? null
      : new Date(this.warehousingHeader.flightDtTimeZone).toISOString();

    // 設定更新使用者
    this.warehousingHeader.updateUser = this.userProfile.userName;
  }

  /**
   * 驗證日期欄位
   */
  private validateDateFields(): boolean {
    if (!isNullOrEmpty(this.warehousingOriginHeader.expectedDtTimeZone)) {
      if (isNullOrEmpty(this.warehousingHeader.expectedDtTimeZone)) {
        this.toastService.error(
          this.translateService.instant('ReceiptFormHeaderDetailsEdit.EditMsg.EstimatedArrivedDtCannotNull')
        );
        return false;
      }
    }

    if (!isNullOrEmpty(this.warehousingOriginHeader.whDtTimeZone)) {
      if (isNullOrEmpty(this.warehousingHeader.whDtTimeZone)) {
        this.toastService.error(
          this.translateService.instant('ReceiptFormHeaderDetailsEdit.EditMsg.ArrivedDtCannotNull')
        );
        return false;
      }
    }

    return true;
  }

  /**
   * 驗證 HAWB 長度
   */
  private validateHawbLength(): boolean {
    if (!isNullOrEmpty(this.warehousingOriginHeader.hawbNo)) {
      if (this.warehousingHeader.hawbNo.length > 50) {
        this.toastService.error(
          this.translateService.instant('ReceiptFormHeaderDetailsEdit.HAWBNoWordCountExceeds')
        );
        return false;
      }
    }
    return true;
  }

  /**
   * 儲存入庫資料
   */
  private saveWarehousingData(): void {
    this.warehousingSearchService.updateWarehousing(this.warehousingHeader).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave').subscribe({
          next: msg => {
            this.toastService.success(msg);
            this.routeStateService.navigateTo(
              '/TransportOperation/WarehousingHeaderDetail',
              this.warehousingHeader
            );
          }
        });
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
        this.ngOnInit();
      }
    });
  }

  /**
   * 載入現有資料時，設定表單值
   */
  loadWarehousingData(data: any): void {
    // 設定位置資料
    const fromLocation = {
      country: data.fromCountry || null,
      city: data.fromCity || null,
      area: data.fromArea || null
    };

    const toLocation = {
      country: data.toCountry || null,
      city: data.toCity || null,
      area: data.toArea || null
    };

    const consolidationFromLocation = {
      country: data.consolidationFromCountry || null,
      city: data.consolidationFromCity || null,
      area: data.consolidationFromArea || null
    };

    const consolidationToLocation = {
      country: data.consolidationToCountry || null,
      city: data.consolidationToCity || null,
      area: data.consolidationToArea || null
    };

    // 設定表單值
    this.editForm.patchValue({
      ...data,
      fromLocation: fromLocation,
      toLocation: toLocation,
      consolidationFromLocation: consolidationFromLocation,
      consolidationToLocation: consolidationToLocation,
    });

    // 同步到 warehousingHeader
    this.warehousingHeader = {
      ...data
    };

    console.log('Warehousing data loaded:', data);
  }

  goToLastPage(): void{
    this.routeStateService.loadPrevious();
  }

  changeValidation(){
    // if(this.editForm.controls.hawbNo.valid)
    console.log('this.editForm.controls.hawbNo',this.editForm.controls.hawbNo);
    console.log('set',this.editForm.controls.hawbNo.setValidators(Validators.required));

    if(this.warehousingHeader.deliveryType == 'DECLARATION'){
      this.editForm.controls.vendorCustomer.clearValidators();
      this.editForm.controls.totalCartonCnt.clearValidators();
      this.editForm.controls.hawbNo.clearValidators();
      this.editForm.controls.totalChargeableWeight.clearValidators();
    } else if (this.warehousingHeader.deliveryType == 'LOCAL'){
      this.editForm.controls.vendorCustomer.setValidators(Validators.required);
      this.editForm.controls.totalCartonCnt.setValidators(Validators.required);
      this.editForm.controls.hawbNo.setValidators(Validators.required);
      this.editForm.controls.totalChargeableWeight.setValidators(Validators.required);
    }else{
      this.editForm.controls.vendorCustomer.setValidators(Validators.required);
      this.editForm.controls.totalCartonCnt.setValidators(Validators.required);
      this.editForm.controls.hawbNo.setValidators(Validators.required);
      this.editForm.controls.totalChargeableWeight.setValidators(Validators.required);
    }
    this.editForm.controls.vendorCustomer.updateValueAndValidity();
    this.editForm.controls.totalCartonCnt.updateValueAndValidity();
    this.editForm.controls.hawbNo.updateValueAndValidity();
    this.editForm.controls.totalChargeableWeight.updateValueAndValidity();
    this.editForm.controls.shipTerm.clearValidators();

    if (this.isShipTermEdit) {
      this.editForm.controls.shipTerm.setValidators(Validators.required);
    }
  }

  showValidationMessage(control: AbstractControl | null, submitted: boolean): boolean {
    return ValidationUtils.showValidationMessage(control, submitted);
  }

  updateValidity(control: AbstractControl): boolean{
    return control.validator !== null;
  }

 changeBillObject(): void {
    const billObjectType = this.warehousingHeader.billObjectType;
    this.warehousingHeader.billObject = '';

    this.facilityService.getBillObjectOptions(this.warehousingHeader.facility, billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });
  }

  changeBillCorpOptions(): void {
    const orgId = this.warehousingHeader.orgId;
    if ( orgId != this.preOrgId ) {
      this.facilityService.getLetterOrgOptions(this.laasSetting.facility, orgId)
      .subscribe({
        next: (options: any[]) => {
          this.billCorpOptions = [...options].map((x: any) => {
            return {
              label: `${x.billOUCode}-${x.billOUName} (${x.billReferenceCode})`,
              value: x.billOUCode,
            };
          });

          if (this.billCorpOptions.length === 0 || isNullOrEmpty(this.billCorpOptions[0].value) ){
            this.toastService.error(this.translateService.instant("ReceiptFormHeaderDetails.Message.CantFindBillCorp"))
            this.warehousingHeader.orgId = this.preOrgId;
            this.editForm.controls.orgId.setValue(this.preOrgId);
            return;
          }else{
            this.editForm.controls.billCorp.setValue(this.billCorpOptions[0].value);
            this.warehousingHeader.billCorp = this.billCorpOptions[0].value;
            this.preOrgId = orgId;
          }
        }
      });
    }
  }

}
